import { Buffer } from 'buffer';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';


import { faClipboard, faCloudDownloadAlt, faCodeBranch, faDoorOpen, faEdit, faList, faLock, faPenSquare, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../mcss/menu.css';

import { faUser } from '@fortawesome/free-regular-svg-icons';
import * as Common from '../mc/Common';

function Menu() {
    const navigate = useNavigate();
    const { state } = useLocation();

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);

    const [allRight, setAllRight] = useState([]);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'allrightquery'], function (result) {
                let base64ToString;
                let resp;
                let resp1;
                try {
                    base64ToString = Buffer.from(result, "base64").toString();
                    resp = JSON.parse(base64ToString);
                } catch (error) {
                    resp = JSON.parse('{"LOGOUT": ""}');;
                }
                try {
                    resp1 = JSON.parse(result);
                } catch (error) {
                    resp1 = JSON.parse('{"status": ""}');
                }

                setAllRight(resp);
                if (resp.LOGOUT === "0" || resp1.status === "MSG0002") {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid]);

    function goToPage(id) {
        clearInterval(sessionStorage.myInterval);
        Common.setPageTitle(0);
        switch (id) {
            case 0:
                sessionStorage.clear();
                navigate('/');
                break;
            case 'country':
                navigate('/country-list');
                break;
            case 'state':
                navigate('/state-list');
                break;
            case 'city':
                navigate('/city-list');
                break;
            case 'isd':
                navigate('/isd-list');
                break;
            case 'issuer':
                navigate('/issuer-list');
                break;
            case 'entity':
                navigate('/entity-list');
                break;
            case 'right':
                navigate('/right-list');
                break;
            case 'user':
                navigate('/user-list');
                break;
            case 'new-request':
                navigate('/new-request');
                break;
            case 'new-enquiry':
                navigate('/new-enquiry');
                break;
            case 'enquiry-status':
                navigate('/enquiry-status');
                break;
            case 'in-progress':
                navigate('/in-progress');
                break;
            case 'in-progress1':
                navigate('/in-progress1');
                break;
            case 'entitycontract':
                navigate('/entitycontract');
                break;
            case 'entitylocation':
                navigate('/entitylocation');
                break;
            case 'ratecard':
                navigate('/rate-card');
                break;
            case 'purpose':
                navigate('/purpose');
                break;
            case 'reptransaction':
                navigate('/reptransaction');
                break;
            case 'repdataextract':
                navigate('/repdataextract');
                break;
            case 'replog':
                navigate('/replog');
                break;
            case 'repdealused':
                navigate('/repdealused');
                break;
            case 'reppayment':
                navigate('/reppayment');
                break;
            case 'repbooking':
                navigate('/repbooking');
                break;
            case 'repenquiry':
                navigate('/repenquiry');
                break;
            case 'repupload':
                navigate('/repupload');
                break;
            case 'swift':
                navigate('/swift');
                break;
            case 'loanreport':
                navigate('/loanreport');
                break;
            case 'inwardlist':
                navigate('/inwardlist');
                break;
            case 'inwardreport':
                navigate('/inwardreport');
                break;
            case 'paxlistreport':
                navigate('/paxlistreport');
                break;
            case 'downloads':
                navigate('/downloads');
                break;
            case 'enquirydetail':
                navigate('/enquirydetail');
                break;
            case 'specialapproval':
                navigate('/specialapproval');
                break;
            case 'agentmisreport':
                navigate('/misreport');
                break;
            case 'agentbusinessreport':
                navigate('/businessreport');
                break;
            case 'chngpass':
                navigate('/changepassword', { state: { changePass: true } });
                break;
            case 'booking-module':
                navigate('/booking-module');
                break;
            case 'samplepage':
                navigate('/sample-page');
                break;
            case 'individualprofile':
                navigate('/individual-profile');
                break;
            case 'newrequest_cnvtm':
                navigate('/new-request-cn-vtm');
                break;
            case 'newrequest_cncard':
                navigate('/new-request-cn-card');
                break;
            case 'uploadutr':
                navigate('/upload-utr');
                break;
            case 'utrbalance':
                navigate('/utr-utilization');
                break;
            case 'ad2Modification':
                navigate('/ad2-modification');
                break;
            case 'Ad1':
                navigate('/Ad1');
                break;
            case 'charges':
                navigate('/charges');
                break;
            default:
                navigate('/');
                break;
        }

    }

    return (
        <>
            <div className="textRight mt-0 p-0 userStrip">
                {sessionStorage.entityname}&nbsp;&nbsp;({sessionStorage.userName})&nbsp;&nbsp;
            </div>
            <div className="menuBar">
                <ul>
                    {
                        sessionStorage.entityType === "B" ?
                            <li style={{ display: allRight.ADMIN === "1" ? 'block' : 'none' }} >
                                <div><FontAwesomeIcon icon={faLock} />&nbsp;Admin</div>
                                <div className="subMenu1">
                                    <ul>
                                        <li style={{ display: allRight.INDIVIDUALPROFILE === "1" ? 'block' : 'none' }}
                                            onClick={(e) => goToPage('individualprofile')}><div>Individual Profile</div></li>
                                        <li style={{ display: allRight.AREA === "1" ? 'block' : 'none' }} ><div>Area</div>
                                            <div className="subMenu2">
                                                <ul>
                                                    <li style={{ display: allRight.COUNTRY === "1" ? 'block' : 'none' }}
                                                        onClick={(e) => goToPage('country')}><div>Country</div></li>
                                                    <li style={{ display: allRight.STATE === "1" ? 'block' : 'none' }}
                                                        onClick={(e) => goToPage('state')}><div>State</div></li>
                                                    <li style={{ display: allRight.CITY === "1" ? 'block' : 'none' }}
                                                        onClick={(e) => goToPage('city')}><div>City</div></li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li style={{ display: allRight.CURRENCY === "1" ? 'block' : 'none' }}
                                            onClick={(e) => goToPage('isd')}><div>Currency</div></li>
                                        <li style={{ display: allRight.ISSUER === "1" ? 'block' : 'none' }}
                                            onClick={(e) => goToPage('issuer')}><div>Issuer</div></li>
                                        <li style={{ display: allRight.ENTITY === "1" ? 'block' : 'none' }}
                                            onClick={(e) => goToPage('entity')}><div>Entity</div></li>
                                        <li style={{ display: allRight.ENTITYCONTRACT === "1" ? 'block' : 'none' }}
                                            onClick={(e) => goToPage('entitycontract')}><div>Entity Contract</div></li>
                                        <li style={{ display: allRight.ENTITYLOCATION === "1" ? 'block' : 'none' }}
                                            onClick={(e) => goToPage('entitylocation')}><div>Entity Location</div></li>
                                        <li style={{ display: allRight.PURPOSE === "1" ? 'block' : 'none' }}
                                            onClick={(e) => goToPage('purpose')}><div>Purpose</div></li>
                                        <li style={{ display: allRight.RIGHT === "1" ? 'block' : 'none' }}
                                            onClick={(e) => goToPage('right')}><div>Rights</div></li>
                                        <li style={{ display: allRight.USER === "1" ? 'block' : 'none' }}
                                            onClick={(e) => goToPage('user')}><div>User</div></li>
                                        <li style={{ display: allRight.SAMPLEPAGE === "1" ? 'block' : 'none' }}
                                            onClick={(e) => goToPage('samplepage')}><div>Sample page</div></li>
                                        <li style={{ display: allRight.BANK_CHARGES === "1" ? 'block' : 'none' }}
                                            onClick={(e) => goToPage('charges')}><div>Bank Charges</div></li>
                                    </ul>
                                </div>
                            </li>
                            : null
                    }
                    <li style={{ display: allRight.ENQUIRY === "1" ? 'block' : 'none' }} ><div><FontAwesomeIcon icon={faClipboard} />&nbsp;Lead</div>
                        <div className="subMenu1">
                            <ul>
                                <li style={{ display: allRight.NEWENQUIRY === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('new-enquiry')}><div>New</div></li>
                                <li style={{ display: allRight.ENQUIRYSTATUS === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('enquiry-status')}><div>Status</div></li>
                                <li style={{ display: allRight.BOOKINGMODULE === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('booking-module')}><div>Booking Module</div></li>
                            </ul>
                        </div>
                    </li>
                    <li style={{ display: allRight.NEWREQUEST === "1" ? 'block' : 'none' }}
                        onClick={(e) => goToPage('new-request')} ><div><FontAwesomeIcon icon={faPenSquare} />&nbsp;New Request</div>
                    </li>
                    <li style={{ display: allRight.INPROGRESS === "1" ? 'block' : 'none' }}
                        onClick={(e) => goToPage('in-progress')} ><div><FontAwesomeIcon icon={faSpinner} />&nbsp;Remittance</div>
                    </li>
                    <li style={{ display: allRight.INWARDLIST === "1" ? 'block' : 'none' }}
                        onClick={(e) => goToPage('inwardlist')} ><div><FontAwesomeIcon icon={faCodeBranch} />&nbsp;Inward</div>
                    </li>
                    <li style={{ display: allRight.COMPLETE === "1" ? 'block' : 'none' }}>
                        <div><FontAwesomeIcon icon={faList} />&nbsp;Complete</div>
                    </li>
                    <li style={{ display: allRight.REPORTS === "1" ? 'block' : 'none' }} ><div><FontAwesomeIcon icon={faClipboard} />&nbsp;Reports</div>
                        <div className="subMenu1">
                            <ul>
                                <li style={{ display: allRight.NEWREQUEST_CN_CARD === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('newrequest_cncard')}><div>CN/CARD</div></li>
                                <li style={{ display: allRight.UTR === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('uploadutr')}><div>UTR Upload</div></li>
                                <li style={{ display: allRight.NEWREQUEST_CN_VTM === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('newrequest_cnvtm')}><div>CN/VTM</div></li>
                                <li style={{ display: allRight.RATECARD === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('ratecard')}><div>Rate Card</div></li>
                                <li style={{ display: allRight.REPTRANSACTION === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('reptransaction')}><div>Transactions</div></li>
                                <li style={{ display: allRight.REPDATAEXTRACT === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('repdataextract')}><div>Data Extract</div></li>
                                <li style={{ display: allRight.REPLOGEXTRACT === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('replog')}><div>Log Report</div></li>
                                <li style={{ display: allRight.REPDEALUSED === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('repdealused')}><div>Deal Used Report</div></li>
                                <li style={{ display: allRight.REPPAYMENT === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('reppayment')}><div>Payment Report</div></li>
                                <li style={{ display: allRight.REPBOOKING === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('repbooking')}><div>Booking Report</div></li>
                                <li style={{ display: allRight.REPENQUIRY === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('repenquiry')}><div>Lead Report</div></li>
                                <li style={{ display: allRight.UPLOADBANKREFNO === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('repupload')}><div>Upload Bank Ref</div></li>
                                <li style={{ display: allRight.REPSWIFTDOWNLOAD === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('swift')}><div>Swift Download</div></li>
                                <li style={{ display: allRight.REPLOAN === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('loanreport')}><div>Loan Report</div></li>
                                <li style={{ display: allRight.REPINWARD === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('inwardreport')}><div>Inward Report</div></li>
                                <li style={{ display: allRight.REPPAXLIST === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('paxlistreport')}><div>Pax List </div></li>
                                <li style={{ display: allRight.REPENQUIRYDETAIL === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('enquirydetail')}><div>Lead Detail</div></li>
                                <li style={{ display: allRight.SPECIALAPPROVAL === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('specialapproval')}><div>Special Approval</div></li>
                                <li style={{ display: allRight.REPAGENTMIS === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('agentmisreport')}><div>Agent MIS</div></li>
                                <li style={{ display: allRight.REPAGENTBUSINESS === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('agentbusinessreport')}><div>Agent Business</div></li>
                                <li style={{ display: allRight.UTRBALANCE === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('utrbalance')}><div>UTR Utilization</div></li>
                                <li style={{ display: allRight.AD1 === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('Ad1')}><div>Ad1</div></li>
                            </ul>
                        </div>
                    </li>
                    <li style={{ display: allRight.DOWNLOADS === "1" ? 'block' : 'none' }}
                        onClick={(e) => goToPage('downloads')} ><div><FontAwesomeIcon icon={faCloudDownloadAlt} />&nbsp;Downloads</div>
                    </li>
                    <li style={{ display: allRight.MODIFICATION === "1" ? 'block' : 'none' }}>
                        <div><FontAwesomeIcon icon={faEdit} />&nbsp;Modification</div>
                        <div className="subMenu1">
                            <ul>
                                <li style={{ display: allRight.AD2MODIFICATION === "1" ? 'block' : 'none' }} >
                                    <div className="menuProfileIcon" onClick={(e) => goToPage('ad2Modification')} >AD2 Modification</div>
                                </li >
                            </ul>
                        </div>
                    </li>
                    <li style={{ display: 'block', right: '0', position: 'absolute' }} >
                        <div className="menuProfileIcon"><FontAwesomeIcon icon={faUser} /></div>
                        <div className="subMenu1">
                            <ul>

                                {/* <li style={{ display: 'block' }} onClick={(e) => goToPage(0)}><div>Log Out</div></li> */}
                                <li style={{ display: 'block' }} onClick={(e) => goToPage('chngpass')}><div>Change Password</div></li>
                                <li style={{ display: allRight.LOGOUT === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage(0)}><div><FontAwesomeIcon icon={faDoorOpen} />&nbsp;Log Out</div>
                                </li>
                            </ul>
                        </div>
                    </li >
                </ul >
            </div >
        </>
    );
}
export default Menu;